import React, { useEffect, useState } from "react";
import "./styles/navebar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { data } from "../CategorySection/DataCategory";
import { ApiMediaURL } from "../../setting/GlobleVariable";
import { SearchEvents } from "../../redux/actions/Events";
import MobileNavbar from "./Components/MobileNavbar";
import NewUIMarketplaceHeader from "./Components/NewUIMarketplaceHeader";
import SportsTicker from "./Components/SportsTicker";

const Navebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [showmenu, setshowmenu] = useState(false);
  const user = useSelector((state) => state.user.user);
  const UserAvatar = ApiMediaURL + "/" + user?.Avatar;
  const UserLocationdata = useSelector((state) => state.user.userlocation);

  useEffect(() => {
    if (location.pathname !== "/tickets") return;
    const q = new URLSearchParams(location.search).get("search");
    if (q) setSearch(q);
  }, [location.pathname, location.search]);

  const searchFunction = async () => {
    const trimmed = String(search || "").trim();
    setshowmenu(false);
    if (!trimmed) {
      navigate("/tickets");
      return;
    }
    navigate(`/tickets?search=${encodeURIComponent(trimmed)}`);
    await dispatch(SearchEvents(trimmed, UserLocationdata));
  };

  return (
    <>
      <SportsTicker />
      <NewUIMarketplaceHeader
        user={user}
        data={data}
        search={search}
        setSearch={setSearch}
        UserAvatar={UserAvatar}
        searchFunction={searchFunction}
      />
      <MobileNavbar
        data={data}
        user={user}
        search={search}
        showmenu={false}
        setSearch={setSearch}
        UserAvatar={UserAvatar}
        setshowmenu={setshowmenu}
        searchFunction={searchFunction}
      />
    </>
  );
};

export default Navebar;
